import styled from 'react-emotion';
import { withTheme } from 'emotion-theming';

export const CompanyPageWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  text-align: center;
`;

export const LoadingWrapper = withTheme(styled.div`
  ${({ theme: { color } }) => `
    display: flex;
    justify-content: center;
    width: 100%;
    svg {
      fill: ${color.accentHover}
    }
  `}
`);

export const ContactLyearnText = withTheme(styled.div`
  ${({ theme: { color }, tcText }) => `
    display: flex;
    align-self: center;
    font-size: 14px;
    line-height: 17px;
    color: ${color.black3};
    a {
      cursor: pointer;
      text-decoration: underline;
      color: ${color.black3};
      :hover {
        color: ${color.black2}
      }
    }
    ${tcText
      && `
      margin: 0 0 63px;
    `}
  `}
`);

export const Row = styled.div`
  display: flex;
  align-items: center;
`;

export const FixWidthColumn = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 428px;
  margin: 0 auto;
  align-items: center;
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
`;

export const Heading = withTheme(styled.div`
  ${({ theme: { color } }) => `
    color: ${color.black1};
    font-size: 23px;
    line-height: 27px;
    margin-bottom: 0px;
    text-transform: inherit;
    font-weight: 400;
  `}
`);

export const SearchInputWrapper = styled.div`
  width: 320px;
  background: white;
`;

export const IntroText = withTheme(styled.div`
  ${({ theme: { color } }) => `
    color: ${color.black3};
    font-size: 16px;
    line-height: 20px;
    margin: 10px 0 25px;
  `}
`);

export const FixText = withTheme(styled.div`
  ${({ theme: { color } }) => `
    font-size: 18px;
    line-height: 22px;
    color: ${color.black2};
    font-weight: 600;
    margin-left: 12px;
  `}
`);

export const DomainWrapper = styled.div`
  display: flex;
  align-items: center;
  min-width: 100%;
  margin-top: 8px;
`;
